export const parseFileName = (
  headers: Record<string, unknown>,
  fallbackFileName: string
): string => {
  const raw = headers['content-disposition'];
  const disposition = typeof raw === 'string' ? raw : '';
  const match =
    disposition.match(/filename\*=UTF-8''([^;\n]+)/i) ??
    disposition.match(/filename=["']?([^"';\n]+)["']?/i);

  return match?.[1] ? decodeURIComponent(match[1]) : fallbackFileName;
};
